import { Input, Label } from "@/components/ui/Input";

export type QualityRmaAddressField = "line1" | "line2" | "city" | "state" | "postalCode";

export type QualityRmaAddressValue = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country?: string;
};

export const EMPTY_RMA_ADDRESS: QualityRmaAddressValue = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  postalCode: "",
};

export function rmaAddressCountry(value: QualityRmaAddressValue): string | null {
  const filled = [value.line1, value.line2, value.city, value.state, value.postalCode].some(
    (part) => part.trim() !== "",
  );
  if (!filled) return null;
  const country = value.country?.trim();
  return country != null && country !== "" ? country : "US";
}

const FIELDS: Array<{ key: QualityRmaAddressField; label: string; suffix: string }> = [
  { key: "line1", label: "Address line 1", suffix: "line1" },
  { key: "line2", label: "Address line 2", suffix: "line2" },
  { key: "city", label: "City", suffix: "city" },
  { key: "state", label: "State", suffix: "state" },
  { key: "postalCode", label: "Postal code", suffix: "zip" },
];

export function QualityRmaAddressFields({
  idPrefix,
  values,
  onChange,
  onFieldCommit,
  disabled = false,
}: {
  idPrefix: string;
  values: QualityRmaAddressValue;
  onChange?: (next: QualityRmaAddressValue) => void;
  onFieldCommit?: (field: QualityRmaAddressField, next: string | null) => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <>
      {FIELDS.map((field) => {
        const inputId = `${idPrefix}-${field.suffix}`;
        return (
          <div key={field.key}>
            <Label htmlFor={inputId}>{field.label}</Label>
            {onFieldCommit != null ? (
              <Input
                id={inputId}
                defaultValue={values[field.key]}
                disabled={disabled}
                onBlur={(event) => {
                  onFieldCommit(field.key, event.target.value.trim() || null);
                }}
              />
            ) : (
              <Input
                id={inputId}
                value={values[field.key]}
                disabled={disabled}
                onChange={(event) => {
                  onChange?.({ ...values, [field.key]: event.target.value });
                }}
              />
            )}
          </div>
        );
      })}
    </>
  );
}
